import { Directive, AfterViewInit, OnDestroy, Optional, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';


@Directive({ selector: '[tab-directive]' })
export class TabDirective implements AfterViewInit, OnDestroy {
  observable: any;
  constructor(@Optional() private autoTrigger: MatAutocompleteTrigger,
    @Optional() private control: NgControl) { }


  //We can control only tab.key, else always you close, you get the selected value, if autoActiveFirstOption is TRUE
  @HostListener('keydown.tab', ['$event.target']) onBlur() {

   if (this.autoTrigger.activeOption) {

      const value = this.autoTrigger.activeOption.value;
      if (this.control) { this.control.control.setValue(value, { emit: true }); }

      this.autoTrigger.writeValue(this.autoTrigger.activeOption.value)
   }

  }

  ngAfterViewInit() { //Default Directive But has issue if autoActiveFirstOption is TRUE

    //   this.observable = this.autoTrigger.panelClosingActions.subscribe(x => {
    //     if (this.autoTrigger.activeOption) {
    //       const value=this.autoTrigger.activeOption.value;
    //       if (this.control)
    //         this.control.control.setValue(value,{emit:true});
    //       this.autoTrigger.writeValue(this.autoTrigger.activeOption.value)
    //     }
    //   })

  }

  ngOnDestroy() {
  //  this.observable.unsubscribe();
  }

}